(function () {
  'use strict';

  // Au départ d'une page, nomme l'image du produit visé (carte de l'accueil) pour qu'elle vole
  // jusqu'à la galerie de la fiche. Transition limitée à l'accueil et aux fiches produit.
  var NAME = 'veji-product';

  function pathOf(url) {
    try { return new URL(url, location.href).pathname; } catch (error) { return ''; }
  }
  function allowed(path) { return path === '/' || /^\/products\/[^/]+\/?$/.test(path); }
  function visible(element) {
    var rect = element.getBoundingClientRect();
    return rect.width > 20 && rect.height > 20 && rect.bottom > 0 && rect.top < innerHeight && rect.right > 0 && rect.left < innerWidth;
  }

  window.addEventListener('pageswap', function (event) {
    var transition = event.viewTransition;
    if (!transition) return;
    var from = location.pathname;
    var to = pathOf(event.activation && event.activation.entry ? event.activation.entry.url : '');
    if (!allowed(from) || !allowed(to) || from === to) {
      transition.skipTransition();
      return;
    }
    // Un seul élément peut porter le nom : la galerie de la page quittée le rend.
    Array.prototype.forEach.call(document.querySelectorAll('.veji-prod-hero-tile'), function (tile) {
      tile.style.viewTransitionName = 'none';
    });
    var handle = to.split('/')[2];
    var card = document.querySelector('a.veji-produits-card-media-link[href*="/products/' + handle + '"]');
    if (card && visible(card)) card.style.viewTransitionName = NAME;
  });

  // Retour par le cache du navigateur : retire les noms posés au départ.
  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    Array.prototype.forEach.call(document.querySelectorAll('.veji-prod-hero-tile, a.veji-produits-card-media-link'), function (element) {
      element.style.viewTransitionName = '';
    });
  });
}());
